/* eslint-disable standard/object-curly-even-spacing */
const defaultState = {
  pd: {
    res: -1
  },
  /*
  prodis_empty: {
    disKH: '',
    proKH: '',
    res: 1,
    state_code: { 'sta_id': 0, 'sta_code': 0, 'acc_code': 0, 'p_code': '00', 'd_code': '0000' },
    emis_age:
    [ { 'ai': 1, 'dt': [0, 0], 'id': null },
      { 'ai': 2, 'dt': [0, 0], 'id': null },
      { 'ai': 3, 'dt': [0, 0], 'id': null },
      { 'ai': 4, 'dt': [0, 0], 'id': null },
      { 'ai': 5, 'dt': [0, 0], 'id': null },
      { 'ai': 6, 'dt': [0, 0], 'id': null },
      { 'ai': 7, 'dt': [0, 0], 'id': null },
      { 'ai': 8, 'dt': [0, 0], 'id': null },
      { 'ai': 9, 'dt': [0, 0], 'id': null },
      { 'ai': 10, 'dt': [0, 0], 'id': null },
      { 'ai': 11, 'dt': [0, 0], 'id': null }
    ],
    emis_dir: {
      'dir_ser': 0,
      'dob': '',
      'edu_code': 0,
      'email': '',
      'gen': 0,
      'id': null,
      'name_en': '',
      'name_kh': '',
      'oid': '',
      'tel_pho': '',
      'tot_ser': 0
    },
    emis_edu:
    [
      { 'dt': [0, 0], 'ec': 1, 'id': null },
      { 'dt': [0, 0], 'ec': 2, 'id': null },
      { 'dt': [0, 0], 'ec': 3, 'id': null },
      { 'dt': [0, 0], 'ec': 4, 'id': null },
      { 'dt': [0, 0], 'ec': 5, 'id': null },
      { 'dt': [0, 0], 'ec': 6, 'id': null },
      { 'dt': [0, 0], 'ec': 7, 'id': null },
      { 'dt': [0, 0], 'ec': 8, 'id': null },
      { 'dt': [0, 0], 'ec': 9, 'id': null },
      { 'dt': [0, 0], 'ec': 10, 'id': null }
    ],
    emis_hiv:
    [
      { 'dt': [0, 0, 0, 0], 'id': null }
    ],
    emis_off:
    [
      { 'dt': [1, 'ថ្នាក់ដឹកនាំមន្ទីរ', 0, 0], 'id': null },
      { 'dt': [2, 'ផែនការនិងគ្រប់គ្រងជំនួយ', 0, 0], 'id': null },
      { 'dt': [3, 'គណនេយ្យនិងទ្រព្យសម្បតិ្តរដ្ឋ', 0, 0], 'id': null },
      { 'dt': [4, 'អប់រំក្រៅប្រព័ន្ធ', 0, 0], 'id': null },
      { 'dt': [5, 'អធិការកិច្ច', 0, 0], 'id': null },
      { 'dt': [6, 'រដ្ឋបាល', 0, 0], 'id': null },
      { 'dt': [7, 'បឋមសិក្សា', 0, 0], 'id': null },
      { 'dt': [8, 'បុគ្គលិកនិងបណ្តុះបណ្តាល', 0, 0], 'id': null },
      { 'dt': [9, 'កីឡា', 0, 0], 'id': null },
      { 'dt': [10, 'មធ្យមសិក្សា', 0, 0], 'id': null },
      { 'dt': [11, 'យុវជន', 0, 0], 'id': null },
      { 'dt': [12, 'អប់រំកុមារតូច', 0, 0], 'id': null },
      { 'dt': [13, '', 0, 0], 'id': null },
      { 'dt': [14, '', 0, 0], 'id': null }
    ],
    emis_oth:
    [
      { dt: [0, 0, 0], 'id': null }
    ],
    emis_pos:
    [
      { 'dt': [0, 0, 0, 0], 'id': null, 'pc': 1 },
      { 'dt': [0, 0, 0, 0], 'id': null, 'pc': 2 },
      { 'dt': [0, 0, 0, 0], 'id': null, 'pc': 3 },
      { 'dt': [0, 0, 0, 0], 'id': null, 'pc': 4 },
      { 'dt': [0, 0, 0, 0], 'id': null, 'pc': 5 },
      { 'dt': [0, 0, 0, 0], 'id': null, 'pc': 6 }
    ],
    emis_sal:
    [
      { 'dt': [0, 0], 'id': null, 'sc': 1 },
      { 'dt': [0, 0], 'id': null, 'sc': 2 },
      { 'dt': [0, 0], 'id': null, 'sc': 3 },
      { 'dt': [0, 0], 'id': null, 'sc': 4 }
    ],
    emis_ser:
    [
      { 'aii': 1, 'dt': [0, 0], 'id': null },
      { 'aii': 2, 'dt': [0, 0], 'id': null },
      { 'aii': 3, 'dt': [0, 0], 'id': null },
      { 'aii': 4, 'dt': [0, 0], 'id': null },
      { 'aii': 5, 'dt': [0, 0], 'id': null },
      { 'aii': 6, 'dt': [0, 0], 'id': null },
      { 'aii': 7, 'dt': [0, 0], 'id': null }
    ]
  }
  */
}

export default defaultState
